// extracted by mini-css-extract-plugin
export default {"root":"Bah_Dk","bg":"GMtpvO"};